<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  height: 100%;
  width: 100%;
  margin: 0px;
  overflow: hidden;
}
#app {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue